module.exports = __webpack_public_path__ + "img/add.ee7b5b40.png";